import {stringify} from "query-string";
import BaseService from "./BaseService";
import Helpers from "../utils/Helpers";

export default class MessageService extends BaseService {

  getMessages(page = 1, pageSize?: number, threadId?: number | string, deleted?: boolean, archived?: boolean, draft?: boolean, lastModifiedAt?: string) {
    const query: any = {page};
    if (pageSize) {
      query['page_size'] = pageSize;
    }
    if (threadId != null) {
      query['thread_id'] = threadId;
    }
    if (deleted) {
      query['deleted'] = 'true';
    }
    if (archived !== undefined) {
      query['archived'] = archived;
    }
    if (draft !== undefined) {
      query['draft'] = draft;
    }
    if (lastModifiedAt) {
      query['last_modified_at'] = lastModifiedAt;
    }
    return this.client.get('/api/messages?' + stringify(query));
  }

  getMessage(id: number) {
    return this.client.get(`/api/messages/${id}`);
  }

  createMessage(data: any) {
    Helpers.cleanNull(data);
    return this.client.post(`/api/messages`, data);
  }

  updateMessage(id: number, data: any) {
    Helpers.cleanNull(data);
    return this.client.patch(`/api/messages/${id}`, data);
  }

  modifyMessage(data: any) {
    if (data.id) {
      return this.updateMessage(data.id, data);
    }
    return this.createMessage(data);
  }

  sendMessage(data: any) {
    Helpers.cleanNull(data);
    return this.client.post(`/api/messages/send`, data);
  }

  archiveMessage(id: number) {
    return this.client.post(`/api/messages/${id}/archive`, {});
  }

  seenMessage(id: number) {
    return this.client.post(`/api/messages/${id}/seen`, {});
  }

  deleteMessage(id: number) {
    return this.client.delete(`/api/messages/${id}`);
  }

  unArchiveMessage(id: number) {
    return this.client.post(`/api/messages/${id}/un-archive`, {});
  }

  getUnreadCount() {
    return this.client.get(`/api/messages/unread`);
  }
}
